import { useNavigate } from 'react-router-dom';
import { Box, Stack } from '@mui/material';

import { PKDFilledButton } from 'components/FilledButton';
import {
  CareList,
  Description,
  EmptyCareList,
  Title,
} from 'components/MyCareNetwork';
import { useListConnectedCareCenters } from 'hooks/MyCareNetwork';
import DefaultWrapper from 'shared-components/DefaultWrapper';
import { Content } from './AddCareCenter/styles';
import { BasicSkeleton } from 'components/SkeletonLoaders';

const MyCareNetwork = () => {
  const navigate = useNavigate();
  const handleAddCareCenter = () => navigate('add-care-center');
  const { connectedCareCenters, isLoading } = useListConnectedCareCenters();
  const crumbs = [{ title: 'My Care Network', isActive: true }];

  return (
    <DefaultWrapper
      crumbs={crumbs}
      showHeader={true}
      margin={{ xs: '10px 18px 0px 18px', lg: '10px 78px 0px 78px' }}>
      <Content
        marginRight={{ xs: '20px', md: '150px', xl: '0' }}
        marginLeft={{ xs: '20px', md: '150px', xl: '0' }}>
        {isLoading
          ? (
            <Box>
              <Title>My Care Network</Title>
              <BasicSkeleton
                height='100px'
              />
            </Box>
          )
          : (
            <>
              {connectedCareCenters.length > 0
                ? (
                  <>
                    <Stack
                      direction='row' justifyContent='space-between'>
                      <Title>My Care Network</Title>
                      <PKDFilledButton
                        onClick={handleAddCareCenter} width='225px'>
                    Add Care Center
                      </PKDFilledButton>
                    </Stack>
                    <CareList
                      careCenters={connectedCareCenters}
                    />
                  </>
                )
                : (
                  <>
                    <Title>My Care Network</Title>
                    <Stack
                      spacing={{ xs: '30px', lg: '108px' }}
                      direction={{ xs: 'column', md: 'row' }}>
                      <Description />
                      <EmptyCareList
                        onAddCareCenter={handleAddCareCenter}
                        sx={{
                          padding      : '2rem 0',
                          marginBottom : {
                            xs : '2rem !important',
                            md : '0 !important',
                          },
                        }}
                      />
                    </Stack>
                  </>
                )}
            </>
          )}
      </Content>
    </DefaultWrapper>
  );
};

export default MyCareNetwork;
